import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: ${props => props.theme.maxWidth};
  box-sizing: border-box;
  margin: 0 auto;
  padding: 30px 60px 200px;
  ${bp('lg')`
    padding: 30px 30px 160px;
  `}

  ${bp('sm')`
    padding: 0 0 100px;
  `}

  > div {
    width: 33.33%;
    padding: 0 40px 20px;
    box-sizing: border-box;
    ${bp('lg')`
      width: 50%;
      padding: 0 40px 20px;
    `}

    ${bp('sm')`
      width: 100%;
      padding: 0 20px 20px;
    `}

    &:last-child {
      margin: auto;
    }
  }
`
